// import VEditor from "./components/VEditor.vue";
import Editor from "./components/Editor.js";
// import TextField from "./components/TextField";

// const VEditorComponents = require.context("./components", true, /.vue$/);

const VEditorPlugin = {
  install: function(Vue) {
    Vue.component("Editor", Editor);
  }
};

let GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(VEditorPlugin);
}

export default VEditorPlugin;
export { Editor };
